<template>
  <div class="share-buttons">
    <FacebookButton />
    <TwitterButton />
    <TelegramButton />
  </div>
</template>
<script>
import TwitterButton from 'vue-share-buttons/src/components/TwitterButton'
import FacebookButton from 'vue-share-buttons/src/components/FacebookButton'
import TelegramButton from 'vue-share-buttons/src/components/TelegramButton'

export default {
  components: {
    TwitterButton,
    FacebookButton,
    TelegramButton
  },
  name: 'ShareButtons'
}
</script>
<style>
</style>
